import React, { useState, useEffect, useMemo } from 'react';
import { useMsal } from "@azure/msal-react";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import {
  Box,
  Typography,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { DataGridTable } from "../Table";
import { Checkbox } from '@mui/material';


const ApprovedOrdersHistory = ({ email }) => {

  const [approvedOrders, setApprovedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { instance, accounts } = useMsal();
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  useEffect(() => {
    const fetchApprovedOrders = async () => {
      try {
        const ordersResponse = await execute(
          "GET",
          `${process.env.REACT_APP_BACKEND_BASE_URL}/api/approveLines/getApprovedOrders`
        );
    
        if (ordersResponse) {
          if (Array.isArray(ordersResponse.approvedOrders) && ordersResponse.approvedOrders.length > 0) {
            const processedOrders = ordersResponse.approvedOrders.map((order, index) => ({
              id: `row-${index}`,
              orderNumber: order.orderNumber || '',
              customer: order.customer || '',
              kline: order.kline || '',
              partName: order.partName || '',
              partDes: order.partDes || '',
              approvedBy: order.name || '',
              quantity: order.quantity || '',
              newQuantity: order.newQuantity !== undefined && order.newQuantity !== null ? order.newQuantity : order.quantity || '',
              closed: order.closed || '',
              delta: order.deltaEnabled !== undefined ? order.deltaEnabled : Boolean(order.delta),
              receivingCustomerCode: order.endcustname || '',
              receivingCustomerName: order.endcustdes || '',
              status: order.success ? "הצליח" : (order.error || ''),
              timestamp: order.timestamp ? new Date(order.timestamp) : null,
            }));
            setApprovedOrders(processedOrders);
          } else {
            setApprovedOrders([]);
            setError('No approved orders found.');
          }
        } else {
          setApprovedOrders([]);
          setError('שגיאה בטעינת ההזמנות המאושרות.');
        }
      } catch (err) {
        console.error('Failed to fetch approved orders:', err);
        setError('שגיאה בטעינת ההזמנות המאושרות.');
        setApprovedOrders([]);
      } finally {
        setLoading(false);
      }
    };
    
    
    fetchApprovedOrders();
  }, [execute, accounts]);

  const CheckboxCellRenderer = (params) => (
    <Checkbox
      checked={params.value === true}
      disabled
    />
  );

  const columns = useMemo(() => [
    { field: 'orderNumber', headerName: 'מספר הזמנה', flex: 1 },
    { field: 'customer', headerName: 'לקוח', flex: 1 },
    { field: 'kline', headerName: 'שורה', flex: 1 },
    { field: 'partName', headerName: 'מק"ט', flex: 1 },
    { field: 'partDes', headerName: 'שם מוצר', flex: 1 },
    { field: 'quantity', headerName: 'כמות מקורית', flex: 1 },
    { field: 'newQuantity', headerName: 'כמות מאושרת', flex: 1 },
    { field: 'closed', headerName: 'שורה סגורה', flex: 1, renderCell: (params) => CheckboxCellRenderer(params) },
    { field: 'delta', headerName: 'הזמנת יתרה', flex: 1, renderCell: (params) => CheckboxCellRenderer(params) },
    { field: 'receivingCustomerCode', headerName: 'מספר לקוח מקבל', flex: 1 },
    { field: 'receivingCustomerName', headerName: 'שם לקוח מקבל', flex: 1 },
    { field: 'timestamp', headerName: 'תאריך אישור', type: 'date', flex: 1 },
    { field: 'approvedBy', headerName: 'אושר על ידי', flex: 1 },
    { field: 'status', headerName: 'סטטוס', flex: 1 },
  
  ], []);
  

  const renderSkeleton = () => (
    <TableContainer component={Paper} >
      <Table>
        <TableHead>
          <TableRow>
            
            {columns.map((column) => (
              <TableCell key={column.field}>
                <Skeleton animation="wave" height={20} width="80%" />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(5)].map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map((column) => (
                
                <TableCell key={`${rowIndex}-${column.field}`}>
                  <Skeleton animation="wave" height={20} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      {loading ? (
        renderSkeleton()
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : approvedOrders.length === 0 ? (
        <Typography>לא נמצאו הזמנות מאושרות</Typography>
      ) : (
        <DataGridTable columns={columns} rows={approvedOrders} />
      )}
    </Box>
  );
};

export default ApprovedOrdersHistory;
